import React from 'react';

function SongCard({ song, action, onAction, showSubmitter }) {
  return (
    <div className="song-card">
      <img 
        src={song.albumCover || '/placeholder.png'} 
        alt={song.name}
        className="song-card-cover"
      />
      <div className="song-card-info">
        <span className="song-card-title">{song.name}</span>
        <span className="song-card-artist">{song.artist}</span>
        {showSubmitter && song.submittedBy && (
          <span className="song-card-submitter">von {song.submittedBy}</span>
        )}
      </div>
      {action === 'add' && (
        <button className="btn btn-small btn-primary" onClick={onAction}>+</button>
      )}
      {action === 'remove' && (
        <button className="btn btn-small btn-danger" onClick={onAction}>×</button>
      )}
    </div>
  );
}

export default SongCard;
